import { useEffect, useState } from 'react';
import {BrowserRouter as Router,Route, Switch} from "react-router-dom";
import { Link } from 'react-router-dom';
import './App.css';
import ImageGallery from './ImageGallery';
import Notfound from './Notfound';

function App() {
  
    return (
    <Router>
       <div className="App">
     <Switch>  
     <Route exact path="/" >
         <ImageGallery/>
      </Route>
      <Route exact path="*" >
         <Notfound/>
      </Route>
     </Switch>
    </div>
    </Router>
    
  );
}

export default App;
